import {Section, Box} from '@miro-site/core'

import React from 'react'

export interface ContentSectionProps {
  main: React.ReactNode
  aside: React.ReactNode
}

const ContentSection: React.FC<ContentSectionProps> = ({main, aside}) => {
  return (
    <Section
      $styles={{
        display: ['block', 'flex'],
        alignItems: [undefined, 'stretch'],
      }}
      $withLastChildPadding={false}
    >
      <Box
        $styles={{
          width: [null, 644, 644, 644],
        }}
        $mb={[82, null, null, null]}
        $mr={[null, 115, 115, 115]}
      >
        {main}
      </Box>
      <Box $styles={{width: [null, 360, 360, 360]}}>{aside}</Box>
    </Section>
  )
}

export default ContentSection
